import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import { FormattedMessage } from 'react-intl';
import './FooterAction.scss';
import {
  isMobileOnly,
} from 'react-device-detect';
const FooterAction = ({
  isSingleButton, leftButton, onLeftButtonClick, rightButton, onRightButtonClick, isTranslate, isDisabled,
}) => (
  <div className={`footer-action ${isSingleButton ? 'footer-action--single' : 'footer-action--double'} ${isMobileOnly ? 'footer-action--mobile' : ''}`}>
    {!isSingleButton && (
    <>
      <Button isSecondary isOutlineButton onButtonClick={onLeftButtonClick} value={isTranslate ? <FormattedMessage id={leftButton} /> : leftButton} />
      <Button isSecondary isDisabled={isDisabled} onButtonClick={onRightButtonClick} value={isTranslate ? <FormattedMessage id={rightButton} /> : rightButton} />
    </>
    )}
    {isSingleButton && (
    <Button type="submit" isSecondary isDisabled={isDisabled} onButtonClick={onRightButtonClick} value={isTranslate ? <FormattedMessage id={rightButton} /> : rightButton} />
    )}
  </div>
);

FooterAction.propTypes = {
  /** is Single Button */
  isSingleButton: PropTypes.bool,
  /** left button value */
  leftButton: PropTypes.node,
  /** left button event */
  onLeftButtonClick: PropTypes.func,
  /** right button value */
  rightButton: PropTypes.node,
  /** right button event */
  onRightButtonClick: PropTypes.func,
  /** is translate value */
  isTranslate: PropTypes.bool,
  /** is submit button disabled */
  isDisabled: PropTypes.bool,
};

FooterAction.defaultProps = {
  isSingleButton: true,
  leftButton: null,
  onLeftButtonClick: () => {},
  rightButton: null,
  onRightButtonClick: () => {},
  isTranslate: false,
  isDisabled: false,
};

export default FooterAction;
